module.exports = __webpack_public_path__ + "media/images/application/template/stripe_logo-51fa3753c7ed4e38b387c75621fefa49.svg";